/**
 * TroiaEmptyState - Estados vazios nativos da plataforma
 * F51: renderiza via ListPageEmpty shared (ícones contextuais via props)
 */

import React from 'react';
import type { EmailFolderType } from '../../shared/types/email.types';
import { ListPageEmpty } from '@/shared/components/ui';
import type { IconName } from '@/shared/icons';

interface TroiaEmptyStateProps {
  type: 'no-selection' | 'empty-folder';
  folder?: EmailFolderType;
}

const FOLDER_EMPTY: Record<string, { icon: IconName; title: string; subtitle: string }> = {
  inbox: { icon: 'inbox', title: 'Caixa de entrada vazia', subtitle: 'Nenhum email novo por enquanto' },
  sent: { icon: 'send', title: 'Nenhum email enviado', subtitle: 'Os emails enviados aparecerão aqui' },
  drafts: { icon: 'file', title: 'Nenhum rascunho', subtitle: 'Rascunhos salvos aparecerão aqui' },
  starred: { icon: 'star', title: 'Nenhum favorito', subtitle: 'Marque emails como favorito para vê-los aqui' },
  archive: { icon: 'archive', title: 'Arquivo vazio', subtitle: 'Emails arquivados aparecerão aqui' },
  spam: { icon: 'alert-octagon', title: 'Nenhum spam', subtitle: 'Emails marcados como spam aparecerão aqui' },
  trash: { icon: 'trash', title: 'Lixeira vazia', subtitle: 'Nenhum email na lixeira' },
};

export const TroiaEmptyState: React.FC<TroiaEmptyStateProps> = ({ type, folder }) => {
  const config =
    type === 'no-selection'
      ? { icon: 'mail' as IconName, title: 'Selecione um email', subtitle: 'Escolha um email da lista para visualizar' }
      : FOLDER_EMPTY[folder || 'inbox'] || FOLDER_EMPTY.inbox;

  return (
    <div
      className="flex-1 flex items-center justify-center px-6 py-12"
      style={{ backgroundColor: 'var(--theme-page-background)' }}
      data-testid={`troia-empty-state-${type}`}
    >
      <div className="w-full max-w-sm">
        <ListPageEmpty
          icon={config.icon}
          message={config.title}
          description={config.subtitle}
        />
      </div>
    </div>
  );
};

TroiaEmptyState.displayName = 'TroiaEmptyState';
